
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component({})
  export default class Annotation extends Vue {
    @Prop({ type: String, required: true }) readonly message!: string;
  }
